import { useEffect, useRef } from "react";
import style from "./Intro.module.css";
import moussaImg from "../Assets/img.png";
const Intro = () => {
  const overLayRef = useRef();

  return (
    <div ref={overLayRef} className={style.overLay}>
      <div className={style.container}>
        <div className={style.name}>
          <span>M</span>
          <span>O</span>
          <span>U</span>
          <span>S</span>
          <span>S</span>
          <span>A</span>
          
        </div>
        <div className={style.chap}>
          <div>
            <div className={style.textureImg}>
              <pre>
	                    <br/>
|                                                                     :^^^:.<br />
|                                                              .:^^~!?5BBBBBG5?~.<br />
|                                                           ^75GB###@@@@@@###@@#BY^<br />
|                                                        .!5B########@####@@##@#@@#5~<br />
|                                                       ^5BBBBBB###@@@@@@##@@#@@@@@@@J.<br />
|                                                      ~B@BBBB@@@@###@@@@@@@@##@@@@@@@7<br />
|                                                     .G#BBBB#BBP5YYY5PPGGB##@@#@@@@@@J<br />
|                                                     !GPPGY5J77!~^^^~~~!!?JY5GBB##@@B^<br />
|                                                     ?P5J7~!^^:^^^^^^^^^^~~~!7?JYPB@@!<br />
|                                                    .YY?~::::^^^^^^^^^^^^~~~!!!7?JYP@J<br />
|                                                    .J7^::::^^^^^^^^^^^^^~~!!!777??YBG.<br />
|                                                   .^?~:::^~!!!~^::^^^^^~~~!!777???YBP.<br />
|                                                   ~^~^::^~!!7JYY?!^^^^~~~~~!!77???JG!<br />
|                                                  .^^^::^^~7?J5YJJ?7~^~!!7JY555YYJJYJ<br />
|                                                  .~~^:::^^^~!7???!~^^!?555PP55Y55Y5:<br />
|                                                   :^^:::::^^~~~^^^^:^!JYJ?J5Y5YJJY!<br />
|                                                   .^~^^::::^^^^^^::^~7??77!!7???JJ.<br />
|                                                    :~^^^^^~!!~^^^:::~!7?7!!~!!7?Y!<br />
|                                                    ^~~~^~7?7!~~!!!^^!????!~~!!?J?:<br />
|                                                    ^~~!~~J??7~!77JYY5PPYYJ?!!7J?:<br />
|                                                    :!!!!~!~!7^^^^~~7??Y5555??YJ.<br />
|                                               .....:~777!!~^^~!!!!~!7?55JJ?YPJ.<br />
|                                       .....:^:^:...^^^7JJJ7~^^!7????JJJ?YY5Y!<br />
|                 .....::::::::::::^^^~~~~~~^~^:.....:!^^!J5J7!~~!!7???J5GGP7.<br />
|               .::^^^~~~~~~~~~~~~~~!!!!!!~^~^.......:7!^^^!JYJ?7?7JY55PG5Y?^<br />
|              .::^^~^~~~~~~~~~~~~!!!!!!~~~~^.....:..:~?~^^^~!?JYY55PP5J?YJ!~^<br />
|             .:.::^~^~~~~~~~~~!!!!!!~~~~~!~^^~!~^::::^77~~~~~~~!????777JGJ^^^^^:<br />
|            .:::::^~~~~~~~~~~~!~!~~~~~~!!!~^~~!~^:....^?7!!!!!!!777777J5Y^:^^:~?7~^:.<br />
|          ..:::::^^~~^~~~~~~~~~~~~~~~~~!!!~~~~!~::.....~?777!!!!!!!7??YY:::::::^?J?77!~:.<br />
|        ..:::::::^^~~^~~~~~~~~~~~~~~~~~~~~!~~~~~:::.....^7?77!!!!!777JJ:.:::::::^???77777!~:.<br />
|       .::::::::^^^~~^~~~~~~~~~~~~~~~~~~~~~~~~~~^:........7J?7!!!77!7?^..:!J7777~~77?7777777!~^<br />
|      .:::::::^^^^^^~^~~~~~~~~~~~~~~~~~!7!!~~~~~^::........?J777!~~^:..:^^7??????7!!7?7!!!!!!77~.<br />
|     .:::::::^^^^^^^~^^^~~~~~~~~~~~~~~~~!!!!~~^~~::....... :?J!^:..::::::^!!!777777??7!!!!!!!!!7^<br />
|    .:::::::^^^^~^^^^^^^^~~~~^^^~~~~~~~~~7!!~~^~~^::....... .^^:^^::::^::.~!!!!7!??77!!!!!!!!!!7~.<br />
|   .::::::^^^^~~~^^^^^^^^^^^^^^^~~~~~~~~~!!!!~^^~~:::..::..:7!:^:::::::^:::~!!77!!!77!!!!!!!!!!!^<br />
| .::::::^^^^^^~~~~^^^^^^^^^^^^^^^^^~~~~~~^!!!~^^~~^::..:...:!^.^::::::::::^~!77!!!!!?!!!!!!!!!!7~<br />
|.::::::^^^^^^~~!!~^^^^^^^^^^^^^^^^^^~~~~~~~!!~~^~~^::..:..... .:::::::::::^~!77!!!777!!!!!!!!!77~<br />
|::::::^^^^^^~~!7!~~~^^^^^^~~^^^^^^^^^~~~~~^~!~~~~~~^::..:......::::::::::^~!77!!!77!!!!!!!!77777~<br />
|:::::^^^^^^^~!77!~~~^^^^^^^^^^^^^^^^^^^~~~~^!~~~~~~^::..:.....:::..::::::^!!7!!!77!!!!!!!!777777^<br />
|:::^^^^^~^^^~!?7!~~~~^^^^^^^^^^^^^^^~^~~~~~~~!~~~~!^::........::::..:::^^~!7!!!777!!!!!!!7?7!777^<br />
|::^^^^^~~~~~~7?7!~!!?^^^^^^^^^^^^^^^^^^^^~~!~~!~~~!~:::.......::.::::::^~!!!!!77!!!!!!!!7?77!777:<br />
|:^^^^^^~~~~~!??7!!!JP^^^^^^^^^^^^^^^^^^^^^~!~~!~~!!~::.......:::..:::::~!!!!!77!!!!!!!!7??77!77~<br />
|^^^^^^~~~~~~!J?7!!?5Y^^^^^^^^^^^^^^^^^^^^^~~!~~!~!7~^:.......^:::..::^~!!!!!77!!7!!!!7?J??77!77:<br />
|^^^^^~~~~~~!7J?777YJ!^^^^^^^^^^^^^^^^^^^^^~~~~~~!!7!^:..^Y~.:^::::..:~!!!!!77!777!!!7?JJ?77!!7~<br />
|::^^~~~~~!!!7Y?77::~~~^^^^^^^^^^^^^^^^^^^~~~~~~^!!7!^:..~?^.::::::::^~!!!777!!77!!!!?YJ?7777!7^<br />
|:^^~~~!!!!!!?Y?7^  ^~^^^^^^^^^^^^^^^^^^^^~~~~~~~~!!!^:.....:::.:::^^~!!!77!!77!!!!7JYJJ?7777!!:<br />
|^^~~~~!!!!!!?Y?~   ^~^^^^^^^^^^^^^^^^^^^^~~~~!~~~7!7^::....::.:::^~~!!7?77!!77!!!7JYJJ??77777!:<br />
|~~~~~~~~!!!7JJ~    ^~^^^^^^^^^^^^^^^^^^^^~~~~!~~~!7!^::....::^^^^~~~!7?77!!!7!!!7YYJJ??7777777:<br />
|~~!!!!!!!!!??^     ^~^^^^^^^^^^^^^^^^^^^^^^~~~~~~~77^::...^^^^^~~~~!?777!!!!!!77YYJJJ?77777!77^<br />
|!!!!~!!!!!77:     .~^^^^^^^^^^^^^^^^^^^^^^^~~~~~~^77~^:::^^^^~~~~~7?77!!!!!!!7?JYJJJ??777!!!77^<br />
|!!!!!!!!!7!.      :~^^^^^^^^^^^^^^^^^^^^^^^~~~~~~^!?!^^^^^::~~~~!??77!!!!!!77?JYYJJ??777!!!777^<br />
|!!!!!!77!!:      .~~^^^^^^^^^^^^^^^^^^^^^^^~~~~~~^~?!^^^^:^~~~!??77!!!!!!!7?????????77777!!7!7~<br />
|!77???JJ^        :~~^^^^^^^^^^^^^^~^^^^^^^^~~~~~~~^755~^^^~~~7?77!!!!!!!77????7!7??77777!!!777^<br />
|????77?J^        :~~^^^^^^^^^^^^^^^~~^^^^^^~~~~~~^^~55~^~!!7?77!!!!!!!77?77?7777???77777777777:<br />
|77??JJJ?.        :~~^^^^^^^^^^^^^^^~~~~^^^^^~~~~~^^~7~~777??!!!!!!!!77?7777777?JJJ??7777777777:<br />
|????JJJ~        :^^~^^^^~^^^^^^^^^^^~~~~~^^^^~~~~^^^7?J???7!!!!!!!777777777777?JJ????77!777777:<br />
|777??J?.       .^^^^^^^^^~~^^^^^^^^^^^~~~~~^^^~~~~^^?PJJ?7!!!!!!77777777777?777JJJ??777777777~<br />
|!!??JJJ~      .^^^^^^^^^^^~~~^^^^^^^^^^~~~~~^^^~~~^^75YJ?7!!!7777777777777?J7!!7JJ????7777!77^<br />
|!!77??J^     .^~~~^^^^^^^^^^~~^^^^^^^^^^~~~~~^^^~~~^!5Y?7777777777777777!7??7?JJJ??7777777777^<br />
                
</pre>
            </div>
          </div>
          <img className={style.img} src={moussaImg} />
        </div>
      </div>
    </div>
  );
};

export default Intro;
